import React from 'react';
import ApproachWrapper from '@modules/insights/integrationApproach/approachWrapper';
import { API } from '@service';
// import { INTEGRATION_APPROACH_TITLE } from '@model';
import { INTEGRATION_APPROACH } from '../insightsDropdown';

function IntegrationApproach(props) {
  return (
    <ApproachWrapper
      // title={INTEGRATION_APPROACH_TITLE}
      fetchService={API.getIntegrationApproach}
      saveService={API.postIntegrationApproach}
      insightSectionKey={INTEGRATION_APPROACH}
      sectionName="Integration"
      {...props}
    />
  );
}

export default IntegrationApproach;
